import {AppConfig} from "../../AppConfig";
import {createHtmlElement, createHtmlElementFromHtml} from "../../lib/domFunctions";
import {Messages} from "../../messages/Messages";
import {FinishedList} from "../FinishedList";
import {DashboardWidget, DashboardWidgetContext} from "./DashboardWidget";

const messages = new Messages();

const TEMPLATE = `
<div class="dashboard-widget-finished__body">
	<div class="p-2 pb-0" data-bind="listFinished"></div>
</div>
`;

export class FinishedListWidget implements DashboardWidget {
	static readonly ID = 'finished-list'

	readonly id = FinishedListWidget.ID
	readonly element: HTMLElement
	readonly headerActions: HTMLElement[]

	private readonly list: FinishedList

	constructor(context: DashboardWidgetContext, content: HTMLElement) {
		this.headerActions = [createHtmlElement('a', {
			class: 'dashboard-widget__action text-muted me-2',
			href: `${AppConfig.CP}/queue/finished`,
			target: '_blank',
			title: messages.get('dashboard.showFinishedRest')
		}, `<i class="bi bi-box-arrow-up-right"></i>`)]

		this.element = createHtmlElementFromHtml(`<div class="dashboard-widget-finished">${TEMPLATE}</div>`)
		content.append(this.element)

		this.list = new FinishedList(this.element, context.playerData)
	}

	dispose() {
		this.list.dispose()
	}
}
